export const MAINTAINENCE_URL = '/arachas-maintenance/index.html';
